import * as React from 'react';

export interface IDeviceMessageProps {
    messages: any[],
    color: string
}

export class DeviceMessage extends React.Component<IDeviceMessageProps> {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        var icon; 
        if(this.props.color === "success") {
                icon = "fa-check";
            }
        else {
            icon = "fa-exclamation-triangle";
            }

        if (this.props.messages != null) {
            return <div>
                {this.props.messages.map((message, index) =>
                    <div key={index} className="col-md-12">
                        <div className={"alert alert-" + this.props.color } role="alert">
                        <i className={"fa " + icon + " icon"}></i>
                        {message}
                    </div>
                </div>
            )}
            </div>
        } else {
            return null;
        }
    }
}
